import { ThemeConfig } from "antd";

export const paveTheme: ThemeConfig = {
  token: {
    // colorPrimary: "#fed330", // yellow
    colorPrimary: "#24b3a7", // mint
    colorLink: "#003d58",
  },
  components: {
    Button: {
      colorPrimaryBg: "#fed330",
      colorPrimary: "#fed330",
      colorPrimaryHover: "#ffe159",
      primaryColor: "#313131",
      colorPrimaryActive: "#dab527",
      colorTextLightSolid: "#313131",
    },
    Switch: {
      colorPrimary: "#fed330",
      colorPrimaryHover: "#ffe159",
    },
    Steps: {
      colorPrimary: "#fed330",
      colorPrimaryHover: "#ffe159",
    },
  },
};
